import style from './TextCard.module.scss';

const TextCard = ({ className, title, text }) => {
  return (
    <div className={`${style.card} ${className}`}>
      <div className={style.card__title}>{title}</div>
      <div
        className={style.card__text}
        dangerouslySetInnerHTML={{ __html: text }}
      ></div>
    </div>
  );
};

export default TextCard;
